const ingredients = (state = null, action) => {
    const { type, payload } = action

    switch (type) {
        case 'FETCH_INGREDIENTS_SUCCESS':
          return payload.ingredients
        case 'FETCH_INGREDIENTS_FAIL':
          return {
            ...state,
          }
        default:
          return state
      }
}

export default ingredients